function validateReport(form){
    let errors = {}
    errors.title = !form.title;
    return errors;
}


export {validateReport};